module.exports = __webpack_public_path__ + "img/Automat_4_RK.e168a274.jpg";